import * as React from "react";
import { Menu, MenuItem } from "@progress/kendo-react-layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faList } from "@fortawesome/free-solid-svg-icons";
import { GridDetailRow } from "@progress/kendo-react-grid";
import { MenuRender } from "../../../Shared/GridComponents/CommonComponents";
import { AppPermissions } from "../../../Shared/Constants/AppPermissions";

export const GenerateNewShift = (generate) => {
    return (
        <div className="pb-1 pt-1 w-100 myorderGlobalicons" onClick={generate}>
            <FontAwesomeIcon icon={faPlusCircle} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Add New Shift{" "}
        </div>
    );
};

export const CustomMenu = (total, generate) => {
    return (
        <Menu openOnClick={true} className="actionItemMenu actionItemMenuThreeDots">
            <MenuItem render={MenuRender}>
                <MenuItem render={() => GenerateNewShift(generate)} />
            </MenuItem>
        </Menu>
    );
};

export class DetailColumnCell extends React.Component<{ dataItem: any; expandChange: any }> {
    render() {
        let dataItem = this.props.dataItem;
        return (
            <td contextMenu="View More" style={{ textAlign: "center" }}>
                <FontAwesomeIcon
                    icon={faList}
                    style={{ marginLeft: "0px!important", marginTop: "0", fontSize: "16px" }}
                    className={"active-icon-blue left-margin cursorPointer"}
                    onClick={() => this.props.expandChange(dataItem)}
                />
            </td>
        );
    }
}

export function DefaultActions(props) {
    const { dataItem } = props;
    var defaultActions = [
        {
            action: "Edit",
            permCode: AppPermissions.REQ_SHIFT_PERMISSION_UPDATE,
            nextState: "",
            icon: "faPencilAlt",
        },
        {
            action: "Delete",
            permCode: AppPermissions.REQ_SHIFT_PERMISSION_DELETE, 
            nextState: "",
            icon: "faTrashAlt",           
        }
    ];
    return defaultActions;
}

export class ViewMoreComponent extends GridDetailRow {
    render() {
        const dataItem = this.props.dataItem;
        return <DialogBox {...dataItem} />;
    }
}

export const DialogBox = (props) => {
    return (
        <div className="row">
            <div className="col-12 col-lg-12 text-dark">
                <div className="row ml-0 mr-0 mt-1">
                    <div className="col-12 pl-0 text-right">                        
                    </div>
                </div>
            </div>
        </div>
    );
};
